export default function traductionMessagesAvertissement(messagesAvertissement) {
  const messages = [];

  messagesAvertissement.forEach((message) => {
    if (message.indexOf('NO_LINE_FOR_MATERIEL_AND_YEAR_WITH_REPLACEMENT') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'detailProduitReseau.popUpInfoTlpe.avertissements.noLineForMaterielAndYearWithRemplacement',
        parametres: { anneeBase: splitMessage[2], anneeRemplacement: splitMessage[3] },
      });
    }
  });
  return messages;
}
